"use client";

import { cva } from "class-variance-authority";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";
import { PROD_EXCHANGE_ENDPOINT } from "constants/index";
import { mixpanelClient } from "analytics/mixpanel";
import { ArrowRight } from "lucide-react";

const promoBannerVariants = cva(
  "m-0! flex cursor-pointer items-center justify-center font-medium text-[#6E53FF]!",
  {
    variants: {
      variant: {
        mobile:
          "tablet:text-sm sticky top-0 z-[11] bg-[#e9e5ff]! py-3 text-xs  md:hidden",
        desktop: "w-fit text-sm"
      }
    },
    defaultVariants: {
      variant: "desktop"
    }
  }
);

export function PromoBanner({
  variant = "desktop"
}: {
  variant?: "mobile" | "desktop";
}) {
  const { isUS } = useCountryStateCookies();

  if (!isUS) return null;

  return (
    <a
      className={promoBannerVariants({ variant })}
      href={`${PROD_EXCHANGE_ENDPOINT}/register?referral=Cryptopedia`}
      id={`cryptopedia-header-gemini-promo-${variant}`}
      onClick={() => {
        mixpanelClient.track(
          `Cryptopedia Header Promo Banner - ${variant} clicked`
        );
      }}
      rel="noopener noreferrer"
      target="_blank"
    >
      Get $20 in bitcoin when you trade $100
      <ArrowRight className="h-4 w-4" />
    </a>
  );
}
